import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData ={
    UserPoolId: 'us-east-2_TqeiHhn5l',
    ClientId: '23rev06a37rj2ldiduisnlfn3h'
}

export default new CognitoUserPool(poolData)